import { useDispatch } from 'store/hooks';
import { useCallback } from 'react';
import { updatePortfolioSummaryConfiguration } from 'widgets/portfolioSummary/store/instances/configuration/actions';
import { PortfolioSummaryColumn } from 'widgets/portfolioSummary/grid/portfolioSummaryGridColumns';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useDispatchUpdatePortfolioSummaryVisibleColumns = () => {
    const { widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    return useCallback(
        (visibleColumns: PortfolioSummaryColumn[]) => {
            dispatch(
                updatePortfolioSummaryConfiguration(widgetKey, {
                    visibleColumns,
                })
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [widgetKey]
    );
};
